import PropTypes from "prop-types";
import { orderBy } from "lodash";

//check if main user has issues
export const hasIssue = (registration) =>
  registration &&
  registration.group[0].issues &&
  Object.keys(registration.group[0].issues).length > 0;

export const isFlagged = (registration) => registration.flagged || false;

// A registration is member if one user in its group is member
export const isMember = (registration) =>
  registration.member ||
  (registration.group &&
    registration.group.filter((user) => user.member).length > 0);

export const sortAndFilterMembers = (queueUsers) =>
  orderBy(
    [].concat(queueUsers).filter((u) => !("reorderIndex" in u) && isMember(u)),
    [
      (member) => {
        const customer = member.group.find((_) => _.member);
        if (!customer || (!customer.sku && !customer.type)) {
          return 0;
        }
        let tier;
        if (customer.sku) {
          [tier] = customer.sku.split("_");
        } else if (customer.type) {
          [tier] = customer.type.split(" ");
        } else {
          tier = "";
        }
        return tier.toLowerCase() === "ultimate" ? 1 : -1;
      },
      "timestamp",
    ],
    ["desc", "asc"]
  );

export const getTierAndTypeFromRegistration = (registration) => {
  const customerMember = (registration.group || []).find((_) => _.member);

  if (!customerMember || (!customerMember.sku && !customerMember.type)) {
    return { tier: "", type: "" };
  }
  let tier, type;
  if (customerMember.sku && customerMember.type) {
    [, , type = ""] = customerMember.sku.split(/[_-]+/);
    [tier] = customerMember.type.split(" ");
  } else if (customerMember.type) {
    [tier, type = ""] = customerMember.type.split(" ");
  } else {
    return { tier: "", type: "" };
  }

  return { tier: tier.toLowerCase(), type: type.toLowerCase() };
};

export const getMembershipSuffix = (tier) => {
  const tiersSuffixDict = {
    ultimate: "U",
    premium: "P",
    instructor: "I",
    basic: "B",
    boomer: "O",
    junior: "J",
  };
  return tiersSuffixDict[tier] || "";
};

// Also detect if there's a membership active, not sure what happens if a group has more than one.
export const isInactive = (registration) =>
  !registration.active ||
  (registration &&
    registration.group.filter((user) => user.member && !user.active).length >
      0);

export const getUserType = (user) => {
  if (user.member && user.active) {
    let tier;
    if (user.type) {
      [tier] = user.type.split(" ");
    } else if (user.sku) {
      [tier] = user.sku.split("_");
    } else {
      tier = "";
    }
    return `M${getMembershipSuffix(tier.toLowerCase())}`;
  }
  if ("minor" in user && user.minor) {
    return "MINOR";
  }

  if (!user.member && !user.active) {
    return "NM";
  }

  return null;
};

export const RegistrationShape = PropTypes.shape({
  member: PropTypes.bool.isRequired,
  flagged: PropTypes.bool,
  timestamp: PropTypes.number.isRequired,
  ranges: PropTypes.object.isRequired,
  rental: PropTypes.bool.isRequired,
  group: PropTypes.arrayOf(
    PropTypes.shape({
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      minor: PropTypes.bool,
      member: PropTypes.bool,
      sku: PropTypes.string,
      type: PropTypes.string,
      flaggedQuestions: PropTypes.arrayOf(
        PropTypes.shape({
          answer: PropTypes.bool,
          negativeIndicator: PropTypes.bool,
          text: PropTypes.string,
        })
      ),
    })
  ),
});

export const LaneShape = PropTypes.shape({
  number: PropTypes.number,
  status: PropTypes.string,
  isMemberOnly: PropTypes.bool,
  label: PropTypes.string,
});

export const MAX_USER_IN_GROUP = 8;

export const rangeLabelsMap = {
  pistol: "Handgun",
  rifle: "Rifle",
};



// WEBPACK FOOTER //
// ./src/staff/utils.js